import React, { useState, useRef, useEffect } from 'react'
import { Platform, ScrollView, ImageBackground, Animated, StyleSheet, Text, TouchableOpacity, useWindowDimensions, Dimensions, View, Image, TextInput, Modal } from 'react-native'

import { useNavigation, useIsFocused, useScrollToTop } from '@react-navigation/native'
import { Ionicons, MaterialCommunityIcons } from '@expo/vector-icons'

import { useQuery, useLazyQuery } from '@apollo/client'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import { FIND_MANY_OBJECT_MAIN, FIND_MANY_TOUR, FIND_MANY_PROMOTION, FIND_MANY_POST } from '../gqls'

import { imageUrl } from '../utils/const'
import { favoritesVar } from '../utils/cache'

import { useUser } from '../hooks/user'

import Loading from '../components/Loading'
import Error from '../components/Error'
import Footer from '../components/Footer'
import Window from '../components/Window'
import { Calendar } from 'react-native-calendars';
import Select from 'react-select'

import logo from '../../assets/logo.png'
import { handleError } from '@apollo/client/link/http/parseAndCheckHttpResponse'

const MainScreen = () => {
    const { width } = useWindowDimensions()
    const navigation = useNavigation()
    const isFocused = useIsFocused()
    const { user, refetch } = useUser()
    const objectScrollRefs = useRef([])
    const tourScrollRefs = useRef([])
    const postScrollRefs = useRef([])
    const [filterTabs, setFilterTabs] = useState(true)
    const [filterTabsMobile, setFilterTabsMobile] = useState(true)
    const [dateFilter, setDateFilter] = useState('')
    const [peopleFilter, setPeopleFilter] = useState('')
    const [searchQuery, setSearchQuery] = useState('');
    const [debouncedQuery, setDebouncedQuery] = useState(searchQuery);
    const [searchValue, setSearchValue] = useState('');
    const [modalCalendar, setModalCalendar] = useState(false)
    const [modalFilter, setModalFilter] = useState(false)
    const [showCalendarFilter, setShowCalendarFilter] = useState(false)
    const [isSearchListVisible, setIsSearchListVisible] = useState(false);
    const [isStandalone, setIsStandalone] = useState(false);

    const [formattedDate, setFormattedDate] = useState('');
    const today = dayjs().format('YYYY-MM-DD');
    const opacityAnim = useRef(new Animated.Value(0)).current;
    const [selectCatalog, setSelectCatalog] = useState(0)
    const ref = useRef(null);
    useScrollToTop(ref);

    useEffect(() => {
        if (isFocused) {
            refetch()
        }
    }, [isFocused])

    useEffect(() => {
        const checkStandalone = () => {
            const isInStandaloneMode = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
            setIsStandalone(isInStandaloneMode);
        };

        checkStandalone();
    }, []);

    useEffect(() => {
        if (dateFilter) {
            const formatDate = (date) => {
                const [year, month, day] = date.split('-');
                return `${day}.${month}.${year}`;
            };

            setFormattedDate(formatDate(dateFilter)); // обновляем состояние отформатированной даты
        }
    }, [dateFilter]);

    useEffect(() => {
        if (modalCalendar) {
            Animated.timing(opacityAnim, {
                toValue: 1, // Полностью видимый элемент
                duration: 300, // Длительность анимации в миллисекундах
                useNativeDriver: true, // Использование нативных драйверов для улучшенной производительности
            }).start();
        } else {
            Animated.timing(opacityAnim, {
                toValue: 0, // Полностью скрытый элемент
                duration: 300,
                useNativeDriver: true,
            }).start();
        }
    }, [modalCalendar, opacityAnim]);

    const isMobile = width <= 1024;

    const places = [
        {
            label: 'г. Якутск',
            value: 'yakutsk',
            type: 'place'
        },
        {
            label: 'г. Якутск, Вилюйский тракт',
            value: 'vilyuyskiy',
            type: 'place'
        },
        {
            label: 'г. Якутск, Маганский тракт',
            value: 'maganskiy',
            type: 'place'
        },
        {
            label: 'г. Якутск, Намский тракт',
            value: 'namskiy',
            type: 'place'
        },
        {
            label: 'г. Якутск, Намцырский тракт',
            value: 'namtsyrskiy',
            type: 'place'
        },
        {
            label: 'г. Якутск, Покровский тракт',
            value: 'pokrovskiy',
            type: 'place'
        },
        {
            label: 'г. Якутск, Хатын-Юряхское шоссе',
            value: 'khatyn-yuryakhskoye',
            type: 'place'
        },
        {
            label: 'г. Якутск, Сергеляхское шоссе',
            value: 'sergelyakhskoye',
            type: 'place'
        },
        {
            label: 'г. Якутск, Окружное шоссе',
            value: 'okruzhnoe',
            type: 'place'
        },
        {
            label: 'г. Якутск, мкр. Птицефабрика',
            value: 'pticefabrika',
            type: 'place'
        },
        {
            label: 'г. Якутск, мкр. Кангалассы',
            value: 'khangalassy',
            type: 'place'
        },
        {
            label: 'г. Якутск, с. Пригородный',
            value: 'prigorodniy',
            type: 'place'
        },
        {
            label: 'г. Якутск, с. Старая Табага',
            value: 'tabaga',
            type: 'place'
        },
        {
            label: 'г. Якутск, с. Хатассы',
            value: 'khatassy',
            type: 'place'
        },
        {
            label: 'Амгинский район',
            value: 'amginskiy-rayon',
            type: 'place'
        },
        {
            label: 'Горный район',
            value: 'gorny-rayon',
            type: 'place'
        },
        {
            label: 'Мегино-Кангаласский район',
            value: 'megino-kangalasskiy-rayon',
            type: 'place'
        },
        {
            label: 'Намский район',
            value: 'namskiy-rayon',
            type: 'place'
        },
        {
            label: 'Нерюнгринский район',
            value: 'nerungrinskiy-rayon',
            type: 'place'
        },
        {
            label: 'Хангаласский район',
            value: 'khangalasskiy-rayon',
            type: 'place'
        }
    ]

    const [findManyObjectQuery, { data: findManyObjectData, loading: findManyObjectLoading, error: findManyObjectError }] = useLazyQuery(FIND_MANY_OBJECT_MAIN, {
        fetchPolicy: 'cache-and-network',
        variables: {
            orderBy: [
                {
                    premium: 'desc',
                },
                {
                    createdAt: 'desc'
                }
            ],
        },
    })

    const [findManyTourQuery, { data: findManyTourData, loading: findManyTourLoading, error: findManyTourError }] = useLazyQuery(FIND_MANY_TOUR, {
        fetchPolicy: 'network-only',
        variables: {
            orderBy: [
                {
                    createdAt: 'desc'
                }
            ],
        }
    })

    const [findManyPostQuery, { data: findManyPostData, loading: findManyPostLoading, error: findManyPostError }] = useLazyQuery(FIND_MANY_POST, {
        fetchPolicy: 'network-only',
        variables: {
            orderBy: [
                {
                    createdAt: 'desc'
                }
            ],
        }
    })

    const { data: findManyPromotionData, loading: findManyPromotionLoading, error: findManyPromotionError } = useQuery(FIND_MANY_PROMOTION, {
        fetchPolicy: 'network-only',
        variables: {
            where: {
                status: { equals: true },
            },
            orderBy: [
                {
                    weight: 'asc',
                },
                {
                    createdAt: 'desc'
                }
            ],
        },
        onCompleted: async ({ findManyPromotion }) => {
            const objectIds = findManyPromotion.map(object => object.objects).flat(Infinity)
            await findManyObjectQuery({
                variables: {
                    where: {
                        // id: {
                        //     in: objectIds
                        // },
                        publish: {
                            equals: true
                        }
                    }
                }
            })
            const tourIds = findManyPromotion.map(object => object.tours).flat(Infinity)
            await findManyTourQuery({
                variables: {
                    where: {
                        // id: {
                        //     in: tourIds
                        // },
                        publish: {
                            equals: true
                        }
                    }
                }
            })
            const postIds = findManyPromotion.map(object => object.posts).flat(Infinity)
            await findManyPostQuery({
                variables: {
                    where: {
                        id: {
                            in: postIds
                        }
                    }
                }
            })
        }
    })

    useEffect(() => {
        if (!findManyPromotionLoading && findManyPromotionData) {
            const mediaQuery = window.matchMedia('(max-width: 768px)')

            if (mediaQuery.matches) {
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.async = true;
                script.src = `https://link.ykt.ru/session?a=view&p=50933&mode=async&nocache=${new Date().getTime()}`;

                script.onload = () => {
                    // Здесь можно вызвать bcode_p50933(), если она доступна в глобальной области
                    if (typeof bcode_p50933 === 'function') {
                        setTimeout(() => {
                            const div = document.createElement('div');
                            const mainWrap = document.querySelector('#main-wrap')
                            div.className = 'add-banner'
                            div.innerHTML = bcode_p50933();
                            mainWrap.appendChild(div);

                            const addHeaderTop = div.getBoundingClientRect();
                            const addHeaderTopFinal = addHeaderTop.height

                            findManyPromotionData.findManyPromotion.forEach(promo => {
                                if (document.location.hash == '#' + promo.anchor) {
                                    setTimeout(() => {
                                        const anchor = document.querySelector(`#${promo.anchor}`)
                                        const rect = anchor.getBoundingClientRect();
                                        ref.current?.scrollTo({ y: rect.top + addHeaderTopFinal - 71, animated: true });
                                    }, 50)
                                }
                            });
                        }, 3000);
                    }
                };

                document.body.appendChild(script); // Добавление скрипта в body

                return () => {
                    // Очистка при размонтировании компонента
                    document.body.removeChild(script);
                };
            }
        }
    }, [findManyPromotionLoading, findManyPromotionData])

    const squareSize = width > 1024 ? 484 : width - 32

    if (findManyPromotionLoading || findManyObjectLoading || findManyTourLoading || findManyPostLoading) return <Loading />
    if (findManyPromotionError || findManyObjectError || findManyTourError || findManyPostError) return <Error />
    if (!findManyPromotionData || !findManyObjectData || !findManyTourData || !findManyPostData) return <Loading />

    const { findManyPromotion } = findManyPromotionData
    const { findManyObject } = findManyObjectData
    const { findManyTour } = findManyTourData
    const { findManyPost } = findManyPostData

    const forSearchObjects = findManyObject.filter(object => object.location).map(object => {
        return {
            value: object.name,
            label: object.name,
            type: object.__typename
        }
    })

    const forSearchTours = findManyTour.filter(object => object.location).map(object => {
        return {
            value: object.name,
            label: object.name,
            type: object.__typename
        }
    })

    const filterObjects = (objects, query) => {
        if (!query) return objects;
        return objects.filter(object =>
            object.name.toLowerCase().includes(query.toLowerCase())
        );
    };

    const filterPlaces = (objects, query) => {
        if (!query) return objects;
        return objects.filter(object =>
            object.place.toLowerCase().includes(query.toLowerCase())
        );
    };

    const filterSearchItems = (objects, query) => {
        if (!query) return objects;

        return objects.filter(object => {
            return object.label.toLowerCase().includes(query.toLowerCase()) || object.value.toLowerCase().includes(query.toLowerCase())
        });
    };

    const filterPlacesTour = (objects, query) => {
        if (!query) return objects;
        return objects.filter(object =>
            object.location.toLowerCase().includes(query.toLowerCase())
        );
    };

    const filteredObjects = filterObjects([...findManyObject], debouncedQuery);
    const filteredTours = filterObjects([...findManyTour], debouncedQuery);
    const filteredPlaces = filterPlaces([...findManyObject], debouncedQuery);
    const filteredPlacesTours = filterPlacesTour([...findManyTour], searchQuery);

    const searchListPlaces = filterSearchItems([...places], searchQuery);
    const searchListObjects = filterSearchItems([...forSearchObjects], searchQuery);
    const searchListTours = filterSearchItems([...forSearchTours], searchQuery);

    const sortedAndFilteredItems = [...filteredObjects, ...filteredTours, ...filteredPlaces, ...filteredPlacesTours];

    const searchAndFilteredItems = [...searchListTours, ...searchListObjects, ...searchListPlaces];

    function openObject(id) {
        if (Platform.OS === 'web') {
            if (isMobile) {
                navigation.navigate('ObjectsStack', { screen: 'Object', params: { id: id } });
            } else {
                window.open("/objects/" + id)
            }
        } else {
            navigation.navigate('Object', { id: id })
        }
    }

    function openTour(id) {
        if (Platform.OS === 'web') {
            if (isMobile) {
                navigation.navigate('ToursStack', { screen: 'Tour', params: { id: id } });
            } else {
                window.open("/tours/" + id);
            }
        } else {
            navigation.navigate('Tour', { id: object.id })
        }
    }

    const addToFavorite = (id) => {
        favoritesVar([
            ...new Set([
                ...favoritesVar(),
                id
            ])
        ])
    }

    const removeToFavorite = (id) => {
        const favorites = favoritesVar().filter(object => object !== id)
        favoritesVar([
            ...favorites
        ])
    }

    const getMinPrice = (price) => {
        const prices = price.filter(object => object.status == true).map(object => parseInt(object.price))
        return Math.min(...prices)
    }

    const getMinDiscount = (data) => {
        const discounts = data.filter(object => object.discount && object.status == true).map(object => parseInt(object.discount))
        if (!discounts || discounts.length === 0) return null
        return Math.min(...discounts)
    }

    // const getRating = (requests) => {
    //     if (requests.length === 0) return (0).toFixed(2)
    //     const rating = requests.map(object => object.rating).reduce((a = 0, b = 0) => a + b, 0) / requests.length
    //     if (rating === 0) return (0).toFixed(2)
    //     return rating.toFixed(2)
    // }

    const getTags = (object) => {
        if (object.premium) {
            return (
                <View style={[styles.tagHot, { backgroundColor: '#BCC8B2' }]}>
                    <Text style={styles.hotText}>Интересно</Text>
                </View>
            )
        }
        if (object.hot) {
            return (
                <>
                    <View style={styles.tagHot}>
                        <Text style={styles.hotText}>Горячие</Text>
                    </View>
                    <View style={styles.tagDeadline}>
                        <MaterialCommunityIcons name='history' size={20} color='#000' />
                        <Text style={styles.deadlineText}>осталось 3 дня</Text>
                    </View>
                </>
            )
        }
        return null
    }

    const getPeople = (object) => {
        if (!object.people) return null
        return (
            <View style={{ flexDirection: 'row', alignItems: 'center', marginRight: 8 }}>
                <Ionicons style={{ marginTop: 1.5 }} name='ios-people-outline' size={23} color='#000' />
                <Text style={{ color: '#000', marginLeft: 4, fontSize: 16 }}>{object.people}</Text>
            </View>
        )
    }

    const getSquare = (square) => {
        if (!square) return null
        return (
            <View style={{ flexDirection: 'row', alignItems: 'center', marginRight: 8 }}>
                <Ionicons style={{ marginTop: 1.5 }} name='ios-resize' size={23} color='#101828' />
                <Text style={{ color: '#000', marginLeft: 4, fontSize: 16 }}>{square} м²</Text>
            </View>
        )
    }

    const onScrollNext = (ref, length) => {
        ref.index = ref.index || 0
        if (length > (ref.index + 1)) {
            ref.index = ref.index + 1
            ref.scrollTo({
                x: ref.index * squareSize,
                animation: false
            })
        }
    }

    const onScrollPreview = (ref) => {
        ref.index = ref.index || 0
        if (ref.index !== 0) {
            ref.index = ref.index - 1
            ref.scrollTo({
                x: ref.index * squareSize,
                animation: false
            })
        }
    }

    const getDisabledDates = (today) => {
        const disabledDates = {};
        const currentDate = dayjs(today);

        // Перебираем прошлые дни и помечаем их как disabled
        for (let i = 1; i <= 365; i++) {
            const date = currentDate.subtract(i, 'day').format('YYYY-MM-DD');
            disabledDates[date] = { disabled: true };
        }

        return disabledDates;
    };

    const handleResetCalendar = () => {
        setDateFilter('')
        setFormattedDate('')
        setModalCalendar(false);
    }

    const handleResetFilter = () => {
        setDateFilter('')
        setFormattedDate('')
        setPeopleFilter('')
        setModalFilter(false);
    }

    const handleResetPeopleFilter = () => {
        setPeopleFilter('')
    }

    const handleSubmitSearch = () => {
        if (searchQuery.includes('район')) {
            places.forEach(place => {
                if (place.label == searchQuery) {
                    setTimeout(() => {
                        setDebouncedQuery(place.value)
                    }, 400);
                } else {
                    setDebouncedQuery(searchQuery)
                }
            });
        } else {
            setDebouncedQuery(searchQuery)
        }
    }

    const handleSubmitSearchMobile = () => {
        setModalFilter(false)
        if (searchQuery.includes('район')) {
            places.forEach(place => {
                if (place.label == searchQuery) {
                    setTimeout(() => {
                        setDebouncedQuery(place.value)
                    }, 400);
                } else {
                    setDebouncedQuery(searchQuery)
                }
            });
        } else {
            setDebouncedQuery(searchQuery)
        }
    }

    const handleSubmitFilter = () => {
        navigation.navigate('ObjectsStack', { screen: 'Objects', params: { dateFilter: dateFilter, peopleFilter: peopleFilter } })
        setModalFilter(false)
        setDateFilter('')
        setFormattedDate('')
        setPeopleFilter('')
    }

    const handleSelectSearchList = (object) => {
        setSearchQuery(object.label)
        setIsSearchListVisible(false);
        setModalFilter(false)

        const handler = setTimeout(() => {
            setDebouncedQuery(object.value);
        }, 400);

        return () => {
            clearTimeout(handler);
        };
    }

    const handleResetSearch = () => {
        setSearchQuery('')
        setDebouncedQuery('')
    }

    const handleConfirmCalendar = (day) => {
        setDateFilter(day.dateString);

        if (windowWidth > 768) {
            const handler = setTimeout(() => {
                setModalCalendar(false);
            }, 300);

            return () => {
                clearTimeout(handler);
            };
        }
    }

    const handleDateTab = () => {
        setSearchQuery('')
        setDebouncedQuery('')
        setFilterTabs(true)
    }

    const handlePeopleCount = (text) => {
        const numericValue = text.replace(/[^0-9]/g, '');
        setPeopleFilter(numericValue)
    }

    const handleScroll = (event) => {
        const offsetY = event.nativeEvent.contentOffset.y;

        const addDiv = document.querySelectorAll('.add-header')

        if (offsetY > 0) {
            if (addDiv) {
                addDiv.forEach(add => {
                    add.style.height = 0 + 'px';
                    add.style.opacity = 0;
                })
            }
        } else {
            if (addDiv) {
                addDiv.forEach(add => {
                    add.style.height = 180 + 'px';
                    add.style.opacity = 1;
                })
            }
        }
    };



    const mediaQueryMaxWidth = window.matchMedia('(min-width: 769px)')

    if (mediaQueryMaxWidth.matches) {
        const addHeader = document.querySelector('.add-header')
        console.log(findManyPromotion)
        if (addHeader) {
            findManyPromotion.forEach(promo => {
                if (document.location.hash == '#' + promo.anchor) {
                    setTimeout(() => {
                        const anchor = document.querySelector(`#${promo.anchor}`)
                        const rect = anchor.getBoundingClientRect();
                        ref.current?.scrollTo({ y: rect.top - 340, animated: true });
                    }, 50)
                }
            });
        } else {
            findManyPromotion.forEach(promo => {
                if (document.location.hash == '#' + promo.anchor) {
                    setTimeout(() => {
                        const anchor = document.querySelector(`#${promo.anchor}`)
                        const rect = anchor.getBoundingClientRect();
                        ref.current?.scrollTo({ y: rect.top - 144, animated: true });
                    }, 50)
                }
            });
        }
    }

    return (
        <ScrollView onScroll={handleScroll} scrollEventThrottle={60} ref={ref} style={styles.container}>
            <Window style={{ backgroundColor: '#fff', marginTop: windowWidth > 768 ? 100 : 32, marginBottom: 40, zIndex: 100 }}>
                {/* {
                    <TouchableOpacity onPress={() => navigation.navigate('Filter', { type: 'objects' })} style={[styles.searchContainer, { marginTop: 10 }]}>
                        <Ionicons style={styles.searchIcon} name='ios-search' size={24} />
                        <View>
                            <Text style={styles.searchTitle}>Найти место для отдыха?</Text>
                            <Text style={styles.searchText}>Поиск по дате, фильтр и сортировка</Text>
                        </View>     
                    </TouchableOpacity> 
                } */}
                <View className='banner-add-mobile' style={{ marginTop: windowWidth > 768 ? -100 : -32, marginBottom: 32 }} id="main-wrap">
                    <div id='most50933'></div>
                </View>
                <View style={styles.filterWrap}>
                    {
                        windowWidth > 768 ? (
                            <View style={{ maxWidth: 618, width: '100%' }}>
                                <View style={styles.filterTabsWrap}>
                                    <TouchableOpacity onPress={handleDateTab}>
                                        {
                                            filterTabs ? (
                                                <View>
                                                    <Text
                                                        style={[styles.filterTabBtnActive]}
                                                    >
                                                        По дате
                                                    </Text>
                                                    <View style={{ height: 2, backgroundColor: '#1F2A37', marginTop: 4 }} />
                                                </View>
                                            ) : (
                                                <Text
                                                    style={[styles.filterTabBtn]}
                                                >
                                                    По дате
                                                </Text>
                                            )
                                        }
                                    </TouchableOpacity>
                                    <TouchableOpacity onPress={() => setFilterTabs(false)}>
                                        {
                                            filterTabs ? (
                                                <Text
                                                    style={[styles.filterTabBtn]}
                                                >
                                                    По названию
                                                </Text>
                                            ) : (
                                                <View>
                                                    <Text
                                                        style={[styles.filterTabBtnActive]}
                                                    >
                                                        По названию
                                                    </Text>
                                                    <View style={{ height: 2, backgroundColor: '#1F2A37', marginTop: 4 }} />
                                                </View>
                                            )
                                        }
                                    </TouchableOpacity>
                                </View>
                                <View style={styles.filterInputsWrap}>
                                    {
                                        filterTabs == true ? (
                                            <View style={styles.filterInputsWrapDate}>
                                                <TouchableOpacity onPress={() => setModalCalendar(true)}>
                                                    {dateFilter ? (
                                                        <View style={{ flexDirection: 'row' }}>
                                                            <Text style={[styles.filterInputDate, { color: '#1F2A37' }]}>{formattedDate}</Text>
                                                            <TouchableOpacity onPress={handleResetCalendar}>
                                                                <Text style={styles.filterInputDateDelete}>+</Text>
                                                            </TouchableOpacity>
                                                        </View>
                                                    ) : (
                                                        <Text style={[styles.filterInputDate, { color: '#6B7280' }]}>Дата</Text>
                                                    )}
                                                </TouchableOpacity>
                                                <View style={{ width: 1, height: 32, backgroundColor: '#E5E7EB', marginHorizontal: 20 }} />
                                                <View style={{ width: '100%', flex: 1, paddingRight: 20 }}>
                                                    <TextInput keyboardType='numeric' value={peopleFilter} placeholderTextColor="#6B7280" onChangeText={handlePeopleCount} style={styles.filterInputPeoples} placeholder='Сколько гостей' />
                                                    {
                                                        peopleFilter && (
                                                            <TouchableOpacity onPress={() => setPeopleFilter('')}>
                                                                <Text style={styles.filterInputPeopleDelete}>+</Text>
                                                            </TouchableOpacity>
                                                        )
                                                    }
                                                </View>
                                                <TouchableOpacity onPress={handleSubmitFilter}>
                                                    <Text style={styles.filterInputBtn}>Найти</Text>
                                                </TouchableOpacity>
                                            </View>
                                        ) : (
                                            <View style={styles.filterInputsWrapSearch}>
                                                <View style={{ width: '100%', flex: 1, flexDirection: 'row' }}>
                                                    <TextInput
                                                        style={[styles.filterInputDate, { width: '100%' }]}
                                                        placeholder='Название места, тура или района'
                                                        value={searchQuery}
                                                        onChangeText={(text) => setSearchQuery(text)}
                                                        placeholderTextColor="#6B7280"
                                                        onFocus={() => {
                                                            setIsSearchListVisible(true);
                                                        }}
                                                        onBlur={() => {
                                                            setTimeout(() => {
                                                                setIsSearchListVisible(false);
                                                            }, 200);
                                                        }}
                                                    />
                                                    {
                                                        searchQuery && (
                                                            <TouchableOpacity onPress={handleResetSearch}>
                                                                <Text style={styles.filterInputDateDelete}>+</Text>
                                                            </TouchableOpacity>
                                                        )
                                                    }
                                                </View>
                                                <TouchableOpacity onPress={handleSubmitSearch}>
                                                    <Text style={styles.filterInputBtn}>Найти</Text>
                                                </TouchableOpacity>

                                                {
                                                    searchQuery.length > 0 && isSearchListVisible && searchAndFilteredItems.length > 0 && (
                                                        <View style={styles.searchList}>
                                                            {
                                                                searchAndFilteredItems.slice(0, 7).map((object, index) => (
                                                                    object.type == 'Object' ? (
                                                                        <TouchableOpacity
                                                                            style={styles.searchListItem}
                                                                            onPress={() => handleSelectSearchList(object)}
                                                                        >
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                                <path d="M17.2892 9.46966L15.7874 7.96965L10.5309 2.71959C10.3901 2.57899 10.1991 2.5 10 2.5C9.80088 2.5 9.60992 2.57899 9.4691 2.71959L4.21264 7.96965L2.71079 9.46966C2.57401 9.61112 2.49832 9.80057 2.50003 9.99722C2.50174 10.1939 2.58071 10.382 2.71994 10.521C2.85917 10.6601 3.04751 10.739 3.2444 10.7407C3.44129 10.7424 3.63097 10.6668 3.7726 10.5302L3.99262 10.3104V16C3.99262 16.3978 4.15085 16.7793 4.4325 17.0607C4.71415 17.342 5.09615 17.5 5.49446 17.5H8.49815C8.69731 17.5 8.88831 17.421 9.02914 17.2803C9.16996 17.1397 9.24908 16.9489 9.24908 16.75V13H10.7509V16.75C10.7509 16.9489 10.83 17.1397 10.9709 17.2803C11.1117 17.421 11.3027 17.5 11.5018 17.5H14.5055C14.9039 17.5 15.2858 17.342 15.5675 17.0607C15.8492 16.7793 16.0074 16.3978 16.0074 16V10.3104L16.2274 10.5302C16.369 10.6668 16.5587 10.7424 16.7556 10.7407C16.9525 10.739 17.1408 10.6601 17.2801 10.521C17.4193 10.382 17.4983 10.1939 17.5 9.99722C17.5017 9.80057 17.426 9.61112 17.2892 9.46966ZM14.5055 16H12.2528V13C12.2528 12.6021 12.0945 12.2206 11.8129 11.9393C11.5312 11.658 11.1492 11.4999 10.7509 11.4999H9.24908C8.85076 11.4999 8.46876 11.658 8.18711 11.9393C7.90546 12.2206 7.74723 12.6021 7.74723 13V16H5.49446V8.81041L10 4.31036L14.5055 8.81041V16Z" fill="#374151" />
                                                                            </svg>
                                                                            <Text>{object.label}</Text>
                                                                        </TouchableOpacity>
                                                                    ) : object.type == 'place' ? (
                                                                        <TouchableOpacity
                                                                            style={styles.searchListItem}
                                                                            onPress={() => handleSelectSearchList(object)}
                                                                        >
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                                <path d="M9.99997 1.66667C8.23245 1.66848 6.53785 2.3465 5.28802 3.55195C4.03819 4.7574 3.33521 6.39182 3.33332 8.09659C3.33063 9.4719 3.79001 10.811 4.64265 11.9134C4.65877 11.9404 4.67658 11.9665 4.69599 11.9914L9.28886 17.9858C9.37152 18.0936 9.47923 18.1812 9.60335 18.2415C9.72746 18.3019 9.86453 18.3333 10.0035 18.3333C10.1425 18.3333 10.2796 18.3019 10.4037 18.2415C10.5278 18.1812 10.6355 18.0936 10.7182 17.9858L15.3075 11.9914C15.3269 11.9668 15.3447 11.941 15.3608 11.9142C16.2122 10.8111 16.6703 9.47177 16.6666 8.09659C16.6647 6.39182 15.9618 4.7574 14.7119 3.55195C13.4621 2.3465 11.7675 1.66848 9.99997 1.66667ZM13.8764 10.96C13.8519 10.9911 13.8297 11.0238 13.8097 11.0578L9.99997 16.0302L6.1911 11.0578C6.17055 11.0237 6.148 10.9908 6.12354 10.9592C5.46597 10.1398 5.10977 9.13272 5.1111 8.09659C5.1111 6.84602 5.62617 5.64667 6.54302 4.76238C7.45986 3.8781 8.70336 3.38131 9.99997 3.38131C11.2966 3.38131 12.5401 3.8781 13.4569 4.76238C14.3738 5.64667 14.8889 6.84602 14.8889 8.09659C14.8904 9.13302 14.5342 10.1405 13.8764 10.96Z" fill="#374151" />
                                                                                <path d="M9.99997 4.77189C9.29675 4.77189 8.60933 4.97301 8.02462 5.34983C7.43991 5.72664 6.98419 6.26223 6.71508 6.88885C6.44597 7.51547 6.37556 8.20498 6.51275 8.8702C6.64994 9.53542 6.98857 10.1465 7.48582 10.6261C7.98308 11.1056 8.61661 11.4323 9.30632 11.5646C9.99603 11.6969 10.7109 11.629 11.3606 11.3694C12.0103 11.1099 12.5656 10.6703 12.9563 10.1064C13.347 9.54245 13.5555 8.87943 13.5555 8.20118C13.5543 7.29202 13.1794 6.42043 12.5128 5.77756C11.8463 5.13469 10.9426 4.77302 9.99997 4.77189ZM9.99997 9.91582C9.64836 9.91582 9.30465 9.81526 9.0123 9.62685C8.71994 9.43845 8.49208 9.17066 8.35753 8.85735C8.22297 8.54404 8.18776 8.19928 8.25636 7.86667C8.32496 7.53406 8.49427 7.22854 8.7429 6.98874C8.99153 6.74895 9.30829 6.58564 9.65315 6.51948C9.998 6.45332 10.3555 6.48728 10.6803 6.61705C11.0051 6.74683 11.2828 6.9666 11.4781 7.24857C11.6735 7.53055 11.7777 7.86206 11.7777 8.20118C11.7777 8.65593 11.5904 9.09206 11.2571 9.41362C10.9237 9.73518 10.4715 9.91582 9.99997 9.91582Z" fill="#374151" />
                                                                            </svg>
                                                                            <Text>{object.label}</Text>
                                                                        </TouchableOpacity>
                                                                    ) : object.type == 'Tour' && (
                                                                        <TouchableOpacity
                                                                            style={styles.searchListItem}
                                                                            onPress={() => handleSelectSearchList(object)}
                                                                        >
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                                <path d="M17.5 9.99997C17.5 5.85934 14.1406 2.49997 10 2.49997C5.85938 2.49997 2.5 5.85934 2.5 9.99997C2.5 14.1406 5.85938 17.5 10 17.5C14.1406 17.5 17.5 14.1406 17.5 9.99997Z" stroke="#374151" strokeWidth="1.25" strokeMiterlimit="10" />
                                                                                <path d="M13.6982 5.89579L9.12007 7.72704C8.80565 7.85278 8.52005 8.04109 8.2806 8.28054C8.04115 8.51999 7.85284 8.80559 7.7271 9.12001L5.89585 13.6981C5.87312 13.7549 5.86756 13.8171 5.87985 13.8771C5.89214 13.937 5.92175 13.992 5.965 14.0352C6.00826 14.0785 6.06325 14.1081 6.12318 14.1204C6.1831 14.1327 6.24531 14.1271 6.3021 14.1044L10.8802 12.2731C11.1947 12.1474 11.4803 11.9591 11.7197 11.7196C11.9591 11.4802 12.1475 11.1946 12.2732 10.8802L14.1044 6.30204C14.1272 6.24525 14.1327 6.18304 14.1205 6.12312C14.1082 6.06319 14.0786 6.0082 14.0353 5.96494C13.992 5.92169 13.937 5.89208 13.8771 5.87979C13.8172 5.8675 13.755 5.87306 13.6982 5.89579ZM10.0001 10.9376C9.81473 10.9376 9.63347 10.8826 9.4793 10.7796C9.32513 10.6766 9.20497 10.5302 9.13401 10.3589C9.06306 10.1875 9.04449 9.99905 9.08066 9.81719C9.11684 9.63533 9.20613 9.46829 9.33724 9.33718C9.46835 9.20606 9.6354 9.11678 9.81725 9.0806C9.99911 9.04443 10.1876 9.06299 10.3589 9.13395C10.5302 9.20491 10.6766 9.32507 10.7797 9.47924C10.8827 9.63341 10.9376 9.81467 10.9376 10.0001C10.9376 10.2487 10.8389 10.4872 10.6631 10.663C10.4872 10.8388 10.2488 10.9376 10.0001 10.9376Z" fill="#374151" />
                                                                            </svg>
                                                                            <Text>{object.label}</Text>
                                                                        </TouchableOpacity>
                                                                    )
                                                                ))
                                                            }
                                                        </View>
                                                    )
                                                }
                                            </View>
                                        )
                                    }
                                </View>
                            </View>
                        ) : (
                            <View style={{ flex: 1, width: '-webkit-fill-available', marginHorizontal: 16 }}>
                                <TouchableOpacity
                                    onPress={() => setModalFilter(true)}
                                    style={styles.filterBtnMobile}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                        <path d="M10.2001 17.9C8.77605 17.9 7.38398 17.4777 6.19993 16.6866C5.01589 15.8954 4.09303 14.7709 3.54808 13.4553C3.00312 12.1397 2.86053 10.692 3.13835 9.29535C3.41617 7.89869 4.10191 6.61577 5.10886 5.60883C6.11581 4.6019 7.39874 3.91616 8.79542 3.63835C10.1921 3.36054 11.6398 3.50312 12.9554 4.04807C14.2711 4.59302 15.3956 5.51586 16.1867 6.6999C16.9779 7.88393 17.4002 9.27597 17.4002 10.7C17.398 12.6089 16.6388 14.439 15.2889 15.7888C13.9391 17.1386 12.109 17.8979 10.2001 17.9ZM10.2001 5.3C9.13206 5.3 8.08801 5.61671 7.19997 6.21007C6.31194 6.80343 5.6198 7.64679 5.21108 8.63351C4.80236 9.62023 4.69542 10.706 4.90378 11.7535C5.11215 12.801 5.62645 13.7632 6.38167 14.5184C7.13688 15.2736 8.09908 15.7879 9.14659 15.9962C10.1941 16.2046 11.2799 16.0977 12.2666 15.6889C13.2533 15.2802 14.0967 14.5881 14.6901 13.7001C15.2834 12.8121 15.6002 11.768 15.6002 10.7C15.5987 9.26827 15.0293 7.89559 14.0169 6.8832C13.0045 5.87082 11.6318 5.30143 10.2001 5.3Z" fill="#374151" />
                                        <path d="M20.1002 21.5C19.8615 21.4999 19.6326 21.4051 19.4639 21.2363L15.8638 17.6363C15.6999 17.4666 15.6092 17.2392 15.6112 17.0032C15.6133 16.7673 15.7079 16.5415 15.8748 16.3747C16.0417 16.2078 16.2674 16.1131 16.5034 16.1111C16.7394 16.109 16.9667 16.1998 17.1364 16.3637L20.7365 19.9637C20.8623 20.0896 20.948 20.2499 20.9827 20.4245C21.0174 20.599 20.9996 20.78 20.9315 20.9444C20.8634 21.1088 20.7481 21.2494 20.6001 21.3483C20.4521 21.4472 20.2782 21.5 20.1002 21.5Z" fill="#374151" />
                                    </svg>
                                    <View style={styles.filterBtnMobileText}>
                                        <Text style={{ fontSize: 14, color: '#101828', lineHeight: '150%' }}>Найти место для отдыха</Text>
                                        <Text style={{ fontSize: 12, color: '#6B7280', lineHeight: '150%' }}>Дата • Количество гостей • Название</Text>
                                    </View>
                                </TouchableOpacity>
                            </View>
                        )
                    }
                    <Modal
                        visible={modalFilter}
                        //visible={true}
                        animationType={'fade'}
                        transparent={true}
                    >
                        <ScrollView>
                            <View style={[styles.modalFilter, isStandalone && styles.modalFilterActive ]}>
                                <View style={styles.modalFilterTop}>
                                    <TouchableOpacity
                                        onPress={() => setModalFilter(false)}
                                        style={styles.modalFilterClose}
                                    >
                                        <View>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                <path d="M2.5 2.5L9.5 9.5M9.5 2.5L2.5 9.5" stroke="black" strokeWidth="2" strokeLinecap="round" />
                                            </svg>
                                        </View>
                                    </TouchableOpacity>
                                    <View style={styles.modalFilterTabs}>
                                        <TouchableOpacity onPress={() => setFilterTabsMobile(true)}>
                                            {
                                                filterTabsMobile ? (
                                                    <View>
                                                        <Text style={styles.modalFilterTabsTextActive}>По дате</Text>
                                                        <View style={{ width: '100%', height: 2, backgroundColor: '#1F2A37', marginTop: 4 }} />
                                                    </View>
                                                ) : (
                                                    <Text style={styles.modalFilterTabsText}>По дате</Text>
                                                )
                                            }
                                        </TouchableOpacity>
                                        <TouchableOpacity onPress={() => setFilterTabsMobile(false)}>
                                            {
                                                !filterTabsMobile ? (
                                                    <View>
                                                        <Text style={styles.modalFilterTabsTextActive}>По названию</Text>
                                                        <View style={{ width: '100%', height: 2, backgroundColor: '#1F2A37', marginTop: 4 }} />
                                                    </View>
                                                ) : (
                                                    <Text style={styles.modalFilterTabsText}>По названию</Text>
                                                )
                                            }
                                        </TouchableOpacity>
                                    </View>

                                </View>
                                {
                                    filterTabsMobile ? (
                                        <View style={styles.modalFilterDate}>
                                            <TouchableOpacity onPress={() => setShowCalendarFilter(!showCalendarFilter)} style={styles.modalFilterInputWrap}>
                                                {
                                                    dateFilter ? (
                                                        <Text style={styles.modalFilterInput}>{formattedDate}</Text>
                                                    ) : (
                                                        <Text style={[styles.modalFilterInput, { color: '#6B7280' }]}>Когда</Text>
                                                    )
                                                }
                                                {
                                                    dateFilter && (
                                                        <TouchableOpacity onPress={handleResetCalendar}>
                                                            <Text style={styles.filterInputPeopleDelete}>+</Text>
                                                        </TouchableOpacity>
                                                    )
                                                }
                                                <View>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                        <path d="M12.55 4.1V3.6V2.925C12.55 2.87859 12.5316 2.83407 12.4987 2.80126C12.4659 2.76844 12.4214 2.75 12.375 2.75C12.3286 2.75 12.2841 2.76844 12.2513 2.80126C12.2184 2.83407 12.2 2.87859 12.2 2.925V3.6V4.1H11.7H9.675H9.175V3.6V2.925C9.175 2.87859 9.15656 2.83408 9.12374 2.80126M12.55 4.1L9.12374 2.80126M12.55 4.1H13.05H14.4C14.6254 4.1 14.8416 4.18955 15.001 4.34896C15.1604 4.50837 15.25 4.72457 15.25 4.95V14.4C15.25 14.6254 15.1604 14.8416 15.001 15.001C14.8416 15.1604 14.6254 15.25 14.4 15.25H3.6C3.37457 15.25 3.15837 15.1604 2.99896 15.001C2.83955 14.8416 2.75 14.6254 2.75 14.4V4.95C2.75 4.72457 2.83955 4.50836 2.99896 4.34896C3.15837 4.18955 3.37457 4.1 3.6 4.1H4.95H5.45V3.6V2.925C5.45 2.87859 5.46844 2.83408 5.50126 2.80126C5.53408 2.76844 5.57859 2.75 5.625 2.75C5.67141 2.75 5.71592 2.76844 5.74874 2.80126C5.78156 2.83408 5.8 2.87859 5.8 2.925V3.6V4.1H6.3H8.325H8.825V3.6V2.925C8.825 2.87859 8.84344 2.83408 8.87626 2.80126C8.90908 2.76844 8.95359 2.75 9 2.75C9.04641 2.75 9.09092 2.76844 9.12374 2.80126M12.55 4.1L9.4773 2.4477L9.12374 2.80126M5.45 4.95V4.45H4.95H3.6H3.1V4.95V6.3V6.8H3.6H14.4H14.9V6.3V4.95V4.45H14.4H13.05H12.55V4.95C12.55 4.99641 12.5316 5.04093 12.4987 5.07374C12.4659 5.10656 12.4214 5.125 12.375 5.125C12.3286 5.125 12.2841 5.10656 12.2513 5.07374C12.2184 5.04093 12.2 4.99641 12.2 4.95V4.45H11.7H9.675H9.175V4.95C9.175 4.99641 9.15656 5.04092 9.12374 5.07374C9.09092 5.10656 9.04641 5.125 9 5.125C8.95359 5.125 8.90908 5.10656 8.87626 5.07374C8.84344 5.04092 8.825 4.99641 8.825 4.95V4.45H8.325H6.3H5.8V4.95C5.8 4.99641 5.78156 5.04092 5.74874 5.07374C5.71592 5.10656 5.67141 5.125 5.625 5.125C5.57859 5.125 5.53408 5.10656 5.50126 5.07374C5.46844 5.04092 5.45 4.99641 5.45 4.95ZM3.1 14.4V14.9H3.6H14.4H14.9V14.4V7.65V7.15H14.4H3.6H3.1V7.65V14.4ZM5.50126 9.55126C5.53408 9.51844 5.57859 9.5 5.625 9.5H12.375C12.4214 9.5 12.4659 9.51844 12.4987 9.55126C12.5316 9.58407 12.55 9.62859 12.55 9.675C12.55 9.72141 12.5316 9.76593 12.4987 9.79874C12.4659 9.83156 12.4214 9.85 12.375 9.85H5.625C5.57859 9.85 5.53408 9.83156 5.50126 9.79874C5.46844 9.76592 5.45 9.72141 5.45 9.675C5.45 9.62859 5.46844 9.58408 5.50126 9.55126L5.1477 9.1977L5.50126 9.55126Z" fill="#1F2A37" stroke="#6B7280" />
                                                    </svg>
                                                </View>
                                            </TouchableOpacity>
                                            {
                                                showCalendarFilter && (
                                                    <View>
                                                        <Calendar
                                                            firstDay={1}
                                                            current={today}
                                                            disableAllTouchEventsForDisabledDays={true}
                                                            style={[styles.modalComfortsFormCalendar, { marginTop: 0 }]}
                                                            renderArrow={(direction) => <Ionicons size={20} name={direction === 'left' ? 'ios-chevron-back' : 'ios-chevron-forward'} />}
                                                            theme={{
                                                                selectedDayBackgroundColor: 'rgb(188, 200, 178)',
                                                                todayTextColor: '#000',
                                                                width: '100%',
                                                            }}
                                                            markedDates={{
                                                                [dateFilter]: { selected: true, marked: true, selectedColor: 'rgb(188, 200, 178)' },
                                                                ...getDisabledDates(today),
                                                            }}
                                                            onDayPress={(day) => {
                                                                setDateFilter(day.dateString);
                                                            }}
                                                        />
                                                    </View>
                                                )
                                            }
                                            <View style={styles.modalFilterInputWrap}>
                                                <TextInput
                                                    style={styles.modalFilterInput}
                                                    placeholder='Сколько гостей'
                                                    placeholderTextColor={'#6B7280'}
                                                    keyboardType='numeric'
                                                    onChangeText={setPeopleFilter}
                                                    value={peopleFilter}
                                                />
                                                {
                                                    peopleFilter && (
                                                        <TouchableOpacity onPress={() => setPeopleFilter('')}>
                                                            <Text style={styles.filterInputPeopleDelete}>+</Text>
                                                        </TouchableOpacity>
                                                    )
                                                }
                                                <View>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                        <path d="M11.351 8.80106C11.1006 8.72843 10.8624 8.61478 10.645 8.46436C10.7535 8.31555 10.8548 8.16125 10.9486 8.00205C11.0238 8.05073 11.1025 8.09437 11.1841 8.13257C11.4982 8.27952 11.8444 8.34003 12.189 8.30699C12.5335 8.27397 12.8623 8.14883 13.1442 7.94591C13.4258 7.74313 13.6508 7.46991 13.8001 7.15425C13.9493 6.83869 14.0187 6.48968 14.0031 6.14002C13.9874 5.79035 13.887 5.44921 13.7097 5.14895C13.5323 4.84857 13.283 4.59797 12.9834 4.42339C12.6836 4.24868 12.3443 4.15663 11.9982 4.1579L11.9962 4.15791C11.8908 4.1587 11.7861 4.16821 11.6831 4.18611C11.655 3.99663 11.6176 3.80872 11.571 3.62313C11.7133 3.59501 11.8578 3.58019 12.0028 3.57894C12.406 3.57794 12.8046 3.68075 13.1641 3.88005C13.5242 4.07965 13.835 4.3706 14.0676 4.72967C14.3003 5.08886 14.4469 5.50444 14.493 5.94018C14.539 6.37594 14.4829 6.81651 14.3301 7.22285C14.1774 7.62911 13.9334 7.9872 13.6217 8.26712C13.3102 8.54692 12.9405 8.74023 12.5457 8.83262C12.151 8.92498 11.7411 8.91421 11.351 8.80106ZM15 15.4211H15.5V14.9211V14.1316C15.5 13.3789 15.2162 12.6521 14.7035 12.1125C14.2239 11.6076 13.5798 11.3049 12.8957 11.2672C12.8259 11.0685 12.7461 10.8739 12.6567 10.6842H12.7494C13.6027 10.6853 14.4262 11.0423 15.0378 11.6861C15.6502 12.3308 15.999 13.21 16 14.1321V15.7105C16 15.7953 15.9678 15.8718 15.9178 15.9244C15.8687 15.9761 15.8078 16 15.75 16H13.2337C13.2437 15.9055 13.2491 15.8104 13.25 15.715H13.25V15.7105V15.4211H15ZM2.5 14.9211V15.4211H3H9.75H10.25V14.9211V13.3421C10.25 12.5894 9.96618 11.8627 9.45349 11.323C8.93998 10.7825 8.23786 10.4737 7.5 10.4737H5.25C4.51214 10.4737 3.81002 10.7825 3.29651 11.323C2.78382 11.8627 2.5 12.5894 2.5 13.3421V14.9211ZM6.37481 8.10526C5.81214 8.10522 5.25983 7.92971 4.7876 7.59757C4.31497 7.26514 3.94286 6.78989 3.72218 6.22908C3.50143 5.6681 3.44333 5.04947 3.55615 4.45239C3.66897 3.85539 3.94686 3.31034 4.35101 2.88492C4.75491 2.45977 5.26631 2.17338 5.81904 2.05765C6.37154 1.94197 6.94453 2.00108 7.46672 2.22876C7.98926 2.45659 8.44006 2.84428 8.75907 3.34685C9.07823 3.84964 9.24998 4.44328 9.25 5.05253C9.24903 5.86988 8.93992 6.64864 8.39789 7.21919C7.85669 7.78888 7.12855 8.10428 6.37481 8.10526ZM6.375 2.57895C5.89938 2.57895 5.43673 2.72754 5.04566 3.0026C4.65493 3.27742 4.35413 3.66526 4.17745 4.11425C4.00084 4.56307 3.95498 5.0556 4.04472 5.53052C4.13448 6.00552 4.3566 6.44517 4.68668 6.79261C5.01701 7.14033 5.44106 7.38028 5.90674 7.47778C6.37263 7.57533 6.85525 7.525 7.29237 7.33441C7.72914 7.14397 8.09828 6.82334 8.35614 6.41711C8.61385 6.01112 8.75 5.53634 8.75 5.05263C8.75 4.40461 8.50569 3.7783 8.06332 3.31265C7.62014 2.84614 7.01341 2.57895 6.375 2.57895ZM10.5 16H2.25C2.19221 16 2.13126 15.9761 2.08217 15.9244C2.03225 15.8718 2 15.7953 2 15.7105V13.3424C2.00112 12.4204 2.34981 11.5412 2.96216 10.8967C3.57376 10.2529 4.39733 9.89581 5.25063 9.89474H7.49937C8.35267 9.89581 9.17624 10.2529 9.78784 10.8967C10.4002 11.5413 10.749 12.4205 10.75 13.3427V15.7105C10.75 15.7953 10.7178 15.8718 10.6678 15.9244C10.6187 15.9761 10.5578 16 10.5 16Z" fill="#1F2A37" stroke="#6B7280" />
                                                    </svg>
                                                </View>
                                            </View>
                                            <View style={styles.modalFilterDateBtns}>
                                                <TouchableOpacity
                                                    onPress={handleResetFilter}
                                                >
                                                    <Text style={styles.modalFilterDateReset}>Очистить</Text>
                                                </TouchableOpacity>
                                                <TouchableOpacity
                                                    onPress={handleSubmitFilter}
                                                    style={styles.modalFilterDateSubmit}
                                                >
                                                    <View>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                            <path d="M10.2001 17.4C8.77605 17.4 7.38398 16.9777 6.19993 16.1866C5.01589 15.3954 4.09303 14.2709 3.54808 12.9553C3.00312 11.6397 2.86053 10.192 3.13835 8.79535C3.41617 7.39869 4.10191 6.11577 5.10886 5.10883C6.11581 4.1019 7.39874 3.41616 8.79542 3.13835C10.1921 2.86054 11.6398 3.00312 12.9554 3.54807C14.2711 4.09302 15.3956 5.01586 16.1867 6.1999C16.9779 7.38393 17.4002 8.77597 17.4002 10.2C17.398 12.1089 16.6388 13.939 15.2889 15.2888C13.9391 16.6386 12.109 17.3979 10.2001 17.4ZM10.2001 4.8C9.13206 4.8 8.08801 5.11671 7.19997 5.71007C6.31194 6.30343 5.6198 7.14679 5.21108 8.13351C4.80236 9.12023 4.69542 10.206 4.90378 11.2535C5.11215 12.301 5.62645 13.2632 6.38167 14.0184C7.13688 14.7736 8.09908 15.2879 9.14659 15.4962C10.1941 15.7046 11.2799 15.5977 12.2666 15.1889C13.2533 14.7802 14.0967 14.0881 14.6901 13.2001C15.2834 12.3121 15.6002 11.268 15.6002 10.2C15.5987 8.76827 15.0293 7.39559 14.0169 6.3832C13.0045 5.37082 11.6318 4.80143 10.2001 4.8Z" fill="#111928" />
                                                            <path d="M20.1002 21C19.8615 20.9999 19.6326 20.9051 19.4639 20.7363L15.8638 17.1363C15.6999 16.9666 15.6092 16.7392 15.6112 16.5032C15.6133 16.2673 15.7079 16.0415 15.8748 15.8747C16.0417 15.7078 16.2674 15.6131 16.5034 15.6111C16.7394 15.609 16.9667 15.6998 17.1364 15.8637L20.7365 19.4637C20.8623 19.5896 20.948 19.7499 20.9827 19.9245C21.0174 20.099 20.9996 20.28 20.9315 20.4444C20.8634 20.6088 20.7481 20.7494 20.6001 20.8483C20.4521 20.9472 20.2782 21 20.1002 21Z" fill="#111928" />
                                                        </svg>
                                                    </View>
                                                    <Text style={styles.modalFilterDateSubmitText}>Найти</Text>
                                                </TouchableOpacity>
                                            </View>
                                        </View>
                                    ) : (
                                        <View style={styles.modalFilterDate}>
                                            <View style={styles.modalFilterInputWrap}>
                                                <TextInput
                                                    style={styles.modalFilterInput}
                                                    placeholder='Введите название'
                                                    value={searchQuery}
                                                    onChangeText={(text) => setSearchQuery(text)}
                                                    placeholderTextColor="#6B7280"
                                                    onFocus={() => {
                                                        setIsSearchListVisible(true);
                                                    }}
                                                    onBlur={() => {
                                                        setTimeout(() => {
                                                            setIsSearchListVisible(false);
                                                        }, 200);
                                                    }}
                                                />
                                                {
                                                    searchQuery && (
                                                        <TouchableOpacity onPress={handleResetSearch}>
                                                            <Text style={styles.filterInputPeopleDelete}>+</Text>
                                                        </TouchableOpacity>
                                                    )
                                                }
                                                <View>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                                        <path d="m0 0h24v24h-24z" fill="#fff" opacity="0" />
                                                        <path d="m20.71 19.29-3.4-3.39a7.92 7.92 0 0 0 1.69-4.9 8 8 0 1 0 -8 8 7.92 7.92 0 0 0 4.9-1.69l3.39 3.4a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42zm-15.71-8.29a6 6 0 1 1 6 6 6 6 0 0 1 -6-6z" fill="#6B7280" />
                                                    </svg>
                                                </View>
                                            </View>
                                            {
                                                searchQuery.length > 0 && isSearchListVisible && searchAndFilteredItems.length > 0 && (
                                                    <View style={{ paddingHorizontal: 16 }}>
                                                        <View style={[styles.searchList, { top: 0 }]}>
                                                            {
                                                                searchAndFilteredItems.slice(0, 7).map((object, index) => (
                                                                    object.type == 'Object' ? (
                                                                        <TouchableOpacity
                                                                            style={styles.searchListItem}
                                                                            onPress={() => handleSelectSearchList(object)}
                                                                        >
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                                <path d="M17.2892 9.46966L15.7874 7.96965L10.5309 2.71959C10.3901 2.57899 10.1991 2.5 10 2.5C9.80088 2.5 9.60992 2.57899 9.4691 2.71959L4.21264 7.96965L2.71079 9.46966C2.57401 9.61112 2.49832 9.80057 2.50003 9.99722C2.50174 10.1939 2.58071 10.382 2.71994 10.521C2.85917 10.6601 3.04751 10.739 3.2444 10.7407C3.44129 10.7424 3.63097 10.6668 3.7726 10.5302L3.99262 10.3104V16C3.99262 16.3978 4.15085 16.7793 4.4325 17.0607C4.71415 17.342 5.09615 17.5 5.49446 17.5H8.49815C8.69731 17.5 8.88831 17.421 9.02914 17.2803C9.16996 17.1397 9.24908 16.9489 9.24908 16.75V13H10.7509V16.75C10.7509 16.9489 10.83 17.1397 10.9709 17.2803C11.1117 17.421 11.3027 17.5 11.5018 17.5H14.5055C14.9039 17.5 15.2858 17.342 15.5675 17.0607C15.8492 16.7793 16.0074 16.3978 16.0074 16V10.3104L16.2274 10.5302C16.369 10.6668 16.5587 10.7424 16.7556 10.7407C16.9525 10.739 17.1408 10.6601 17.2801 10.521C17.4193 10.382 17.4983 10.1939 17.5 9.99722C17.5017 9.80057 17.426 9.61112 17.2892 9.46966ZM14.5055 16H12.2528V13C12.2528 12.6021 12.0945 12.2206 11.8129 11.9393C11.5312 11.658 11.1492 11.4999 10.7509 11.4999H9.24908C8.85076 11.4999 8.46876 11.658 8.18711 11.9393C7.90546 12.2206 7.74723 12.6021 7.74723 13V16H5.49446V8.81041L10 4.31036L14.5055 8.81041V16Z" fill="#374151" />
                                                                            </svg>
                                                                            <Text>{object.label}</Text>
                                                                        </TouchableOpacity>
                                                                    ) : object.type == 'place' ? (
                                                                        <TouchableOpacity
                                                                            style={styles.searchListItem}
                                                                            onPress={() => handleSelectSearchList(object)}
                                                                        >
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                                <path d="M9.99997 1.66667C8.23245 1.66848 6.53785 2.3465 5.28802 3.55195C4.03819 4.7574 3.33521 6.39182 3.33332 8.09659C3.33063 9.4719 3.79001 10.811 4.64265 11.9134C4.65877 11.9404 4.67658 11.9665 4.69599 11.9914L9.28886 17.9858C9.37152 18.0936 9.47923 18.1812 9.60335 18.2415C9.72746 18.3019 9.86453 18.3333 10.0035 18.3333C10.1425 18.3333 10.2796 18.3019 10.4037 18.2415C10.5278 18.1812 10.6355 18.0936 10.7182 17.9858L15.3075 11.9914C15.3269 11.9668 15.3447 11.941 15.3608 11.9142C16.2122 10.8111 16.6703 9.47177 16.6666 8.09659C16.6647 6.39182 15.9618 4.7574 14.7119 3.55195C13.4621 2.3465 11.7675 1.66848 9.99997 1.66667ZM13.8764 10.96C13.8519 10.9911 13.8297 11.0238 13.8097 11.0578L9.99997 16.0302L6.1911 11.0578C6.17055 11.0237 6.148 10.9908 6.12354 10.9592C5.46597 10.1398 5.10977 9.13272 5.1111 8.09659C5.1111 6.84602 5.62617 5.64667 6.54302 4.76238C7.45986 3.8781 8.70336 3.38131 9.99997 3.38131C11.2966 3.38131 12.5401 3.8781 13.4569 4.76238C14.3738 5.64667 14.8889 6.84602 14.8889 8.09659C14.8904 9.13302 14.5342 10.1405 13.8764 10.96Z" fill="#374151" />
                                                                                <path d="M9.99997 4.77189C9.29675 4.77189 8.60933 4.97301 8.02462 5.34983C7.43991 5.72664 6.98419 6.26223 6.71508 6.88885C6.44597 7.51547 6.37556 8.20498 6.51275 8.8702C6.64994 9.53542 6.98857 10.1465 7.48582 10.6261C7.98308 11.1056 8.61661 11.4323 9.30632 11.5646C9.99603 11.6969 10.7109 11.629 11.3606 11.3694C12.0103 11.1099 12.5656 10.6703 12.9563 10.1064C13.347 9.54245 13.5555 8.87943 13.5555 8.20118C13.5543 7.29202 13.1794 6.42043 12.5128 5.77756C11.8463 5.13469 10.9426 4.77302 9.99997 4.77189ZM9.99997 9.91582C9.64836 9.91582 9.30465 9.81526 9.0123 9.62685C8.71994 9.43845 8.49208 9.17066 8.35753 8.85735C8.22297 8.54404 8.18776 8.19928 8.25636 7.86667C8.32496 7.53406 8.49427 7.22854 8.7429 6.98874C8.99153 6.74895 9.30829 6.58564 9.65315 6.51948C9.998 6.45332 10.3555 6.48728 10.6803 6.61705C11.0051 6.74683 11.2828 6.9666 11.4781 7.24857C11.6735 7.53055 11.7777 7.86206 11.7777 8.20118C11.7777 8.65593 11.5904 9.09206 11.2571 9.41362C10.9237 9.73518 10.4715 9.91582 9.99997 9.91582Z" fill="#374151" />
                                                                            </svg>
                                                                            <Text>{object.label}</Text>
                                                                        </TouchableOpacity>
                                                                    ) : object.type == 'Tour' && (
                                                                        <TouchableOpacity
                                                                            style={styles.searchListItem}
                                                                            onPress={() => handleSelectSearchList(object)}
                                                                        >
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                                <path d="M17.5 9.99997C17.5 5.85934 14.1406 2.49997 10 2.49997C5.85938 2.49997 2.5 5.85934 2.5 9.99997C2.5 14.1406 5.85938 17.5 10 17.5C14.1406 17.5 17.5 14.1406 17.5 9.99997Z" stroke="#374151" strokeWidth="1.25" strokeMiterlimit="10" />
                                                                                <path d="M13.6982 5.89579L9.12007 7.72704C8.80565 7.85278 8.52005 8.04109 8.2806 8.28054C8.04115 8.51999 7.85284 8.80559 7.7271 9.12001L5.89585 13.6981C5.87312 13.7549 5.86756 13.8171 5.87985 13.8771C5.89214 13.937 5.92175 13.992 5.965 14.0352C6.00826 14.0785 6.06325 14.1081 6.12318 14.1204C6.1831 14.1327 6.24531 14.1271 6.3021 14.1044L10.8802 12.2731C11.1947 12.1474 11.4803 11.9591 11.7197 11.7196C11.9591 11.4802 12.1475 11.1946 12.2732 10.8802L14.1044 6.30204C14.1272 6.24525 14.1327 6.18304 14.1205 6.12312C14.1082 6.06319 14.0786 6.0082 14.0353 5.96494C13.992 5.92169 13.937 5.89208 13.8771 5.87979C13.8172 5.8675 13.755 5.87306 13.6982 5.89579ZM10.0001 10.9376C9.81473 10.9376 9.63347 10.8826 9.4793 10.7796C9.32513 10.6766 9.20497 10.5302 9.13401 10.3589C9.06306 10.1875 9.04449 9.99905 9.08066 9.81719C9.11684 9.63533 9.20613 9.46829 9.33724 9.33718C9.46835 9.20606 9.6354 9.11678 9.81725 9.0806C9.99911 9.04443 10.1876 9.06299 10.3589 9.13395C10.5302 9.20491 10.6766 9.32507 10.7797 9.47924C10.8827 9.63341 10.9376 9.81467 10.9376 10.0001C10.9376 10.2487 10.8389 10.4872 10.6631 10.663C10.4872 10.8388 10.2488 10.9376 10.0001 10.9376Z" fill="#374151" />
                                                                            </svg>
                                                                            <Text>{object.label}</Text>
                                                                        </TouchableOpacity>
                                                                    )
                                                                ))
                                                            }
                                                        </View>
                                                    </View>
                                                )
                                            }
                                            <View>
                                            </View>
                                            <View style={styles.modalFilterSearchBtns}>
                                                <TouchableOpacity
                                                    onPress={handleSubmitSearchMobile}
                                                    style={styles.modalFilterDateSubmit}
                                                >
                                                    <View>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                            <path d="M10.2001 17.4C8.77605 17.4 7.38398 16.9777 6.19993 16.1866C5.01589 15.3954 4.09303 14.2709 3.54808 12.9553C3.00312 11.6397 2.86053 10.192 3.13835 8.79535C3.41617 7.39869 4.10191 6.11577 5.10886 5.10883C6.11581 4.1019 7.39874 3.41616 8.79542 3.13835C10.1921 2.86054 11.6398 3.00312 12.9554 3.54807C14.2711 4.09302 15.3956 5.01586 16.1867 6.1999C16.9779 7.38393 17.4002 8.77597 17.4002 10.2C17.398 12.1089 16.6388 13.939 15.2889 15.2888C13.9391 16.6386 12.109 17.3979 10.2001 17.4ZM10.2001 4.8C9.13206 4.8 8.08801 5.11671 7.19997 5.71007C6.31194 6.30343 5.6198 7.14679 5.21108 8.13351C4.80236 9.12023 4.69542 10.206 4.90378 11.2535C5.11215 12.301 5.62645 13.2632 6.38167 14.0184C7.13688 14.7736 8.09908 15.2879 9.14659 15.4962C10.1941 15.7046 11.2799 15.5977 12.2666 15.1889C13.2533 14.7802 14.0967 14.0881 14.6901 13.2001C15.2834 12.3121 15.6002 11.268 15.6002 10.2C15.5987 8.76827 15.0293 7.39559 14.0169 6.3832C13.0045 5.37082 11.6318 4.80143 10.2001 4.8Z" fill="#111928" />
                                                            <path d="M20.1002 21C19.8615 20.9999 19.6326 20.9051 19.4639 20.7363L15.8638 17.1363C15.6999 16.9666 15.6092 16.7392 15.6112 16.5032C15.6133 16.2673 15.7079 16.0415 15.8748 15.8747C16.0417 15.7078 16.2674 15.6131 16.5034 15.6111C16.7394 15.609 16.9667 15.6998 17.1364 15.8637L20.7365 19.4637C20.8623 19.5896 20.948 19.7499 20.9827 19.9245C21.0174 20.099 20.9996 20.28 20.9315 20.4444C20.8634 20.6088 20.7481 20.7494 20.6001 20.8483C20.4521 20.9472 20.2782 21 20.1002 21Z" fill="#111928" />
                                                        </svg>
                                                    </View>
                                                    <Text style={styles.modalFilterDateSubmitText}>Найти</Text>
                                                </TouchableOpacity>
                                            </View>
                                        </View>
                                    )
                                }
                            </View>
                        </ScrollView>
                    </Modal>
                    <Modal
                        visible={modalCalendar}
                        // visible={true}
                        animationType={windowWidth > 768 ? 'fade' : 'slide'}
                        transparent={true}
                    >
                        <ScrollView>
                            <View style={styles.modalComfortsWrapFirst}>
                                <TouchableOpacity onPress={() => setModalCalendar(false)} style={styles.modalComfortsCloseBtn}></TouchableOpacity>
                                <View style={styles.modalComfortsWrap}>
                                    <View style={styles.modalComfortsClose}>
                                        <Text style={styles.modalComfortsTitle}>Фильтры</Text>
                                    </View>
                                    <View style={styles.modalComfortsForm}>
                                        <Text style={styles.modalComfortsFormTitle}>Дата</Text>
                                        <View style={{ marginBottom: 20 }}>
                                            <Calendar
                                                firstDay={1}
                                                current={today}
                                                disableAllTouchEventsForDisabledDays={true}
                                                style={styles.modalComfortsFormCalendar}
                                                renderArrow={(direction) => <Ionicons size={20} name={direction === 'left' ? 'ios-chevron-back' : 'ios-chevron-forward'} />}
                                                theme={{
                                                    selectedDayBackgroundColor: 'rgb(188, 200, 178)',
                                                    todayTextColor: '#000',
                                                    width: '100%',
                                                }}
                                                markedDates={{
                                                    [dateFilter]: { selected: true, marked: true, selectedColor: 'rgb(188, 200, 178)' },
                                                    ...getDisabledDates(today),
                                                }}
                                                onDayPress={handleConfirmCalendar}
                                            />
                                        </View>
                                    </View>
                                    <View style={styles.modalComfortsFormBtnsWrap}>
                                        <TouchableOpacity style={styles.modalComfortsFormReset} onPress={handleResetCalendar}>
                                            <Text>Очистить</Text>
                                        </TouchableOpacity>
                                        <TouchableOpacity style={styles.modalComfortsFormSubmit} onPress={() => setModalCalendar(false)}>
                                            <Text>Применить</Text>
                                        </TouchableOpacity>
                                    </View>
                                </View>
                            </View>
                        </ScrollView>
                    </Modal>
                </View>
            </Window>
            <Window>
                {
                    debouncedQuery && (
                        <View>
                            <View style={{ marginHorizontal: 16 }}>
                                <Text style={styles.searchQueryResult}>Результаты по запросу поиска</Text>
                            </View>
                            <View style={[styles.objectsContainer, { marginBottom: 24 }]}>
                                {
                                    sortedAndFilteredItems.length == 0 ? (
                                        <View>
                                            <Text style={styles.searchQueryResult}>По вашему результату ничего не найдено</Text>
                                        </View>
                                    ) : (
                                        sortedAndFilteredItems.map((object, index) => (
                                            <TouchableOpacity key={index} onPress={() => openObject(object.id)}>
                                                <ImageBackground style={[styles.objectImage, { height: squareSize, width: squareSize }]} source={object.images_720.length != 0 ? { uri: imageUrl(object.images_720[0]) } : { uri: imageUrl(object.images[0]) }}>
                                                    {
                                                        object.__typename == 'Object' && (
                                                            user ? (
                                                                <>
                                                                    {
                                                                        object.favorite ? (
                                                                            <TouchableOpacity onPress={() => removeToFavorite(object.id)} style={styles.favorite}>
                                                                                <Ionicons name='ios-heart-sharp' size={24} color='#475467' />
                                                                            </TouchableOpacity>
                                                                        ) : (
                                                                            <TouchableOpacity onPress={() => addToFavorite(object.id)} style={styles.favorite}>
                                                                                <Ionicons name='ios-heart-outline' size={24} color='#475467' />
                                                                            </TouchableOpacity>
                                                                        )
                                                                    }
                                                                </>
                                                            ) : <View />
                                                        )
                                                    }
                                                    <View style={styles.tagsContainer}>
                                                        {
                                                            getTags(object)
                                                        }
                                                    </View>
                                                </ImageBackground>
                                                <View style={[styles.infoContainer, { justifyContent: 'space-between', marginTop: 8, alignItems: 'baseline' }]}>
                                                    {
                                                        object.__typename == 'Object' && (
                                                            <Text style={[styles.infoTitle, { maxWidth: squareSize - 200 }]}>{object.name}</Text>
                                                        )
                                                    }
                                                    {
                                                        object.__typename == 'Tour' && (
                                                            <View style={styles.infoGroup}>
                                                                <Text style={[styles.infoTitle, { maxWidth: squareSize - 32 }]}>{object.name}</Text>
                                                            </View>
                                                        )
                                                    }
                                                    {
                                                        object.__typename == 'Object' && (
                                                            <View style={[styles.infoGroup, { maxWidth: 250 }]}>
                                                                {
                                                                    getPeople(object)
                                                                }
                                                                {
                                                                    getSquare(object.square)
                                                                }
                                                                {object.rating > 0 ?
                                                                    <View style={[styles.infoContainer, { justifyContent: 'space-between', alignItems: 'center' }]}>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22" fill="none">
                                                                            <path d="M14.6923 19.7885C14.5641 19.7885 14.4487 19.75 14.3461 19.6731L9.38458 16.0961L4.42304 19.6731C4.32048 19.75 4.20509 19.7885 4.07689 19.7885C3.8974 19.7885 3.74996 19.7308 3.63458 19.6154C3.51919 19.5 3.4615 19.3526 3.4615 19.1731C3.4615 19.0961 3.47432 19.032 3.49996 18.9808L5.42304 13.25L0.423039 9.82691C0.243552 9.69871 0.153809 9.53204 0.153809 9.32691C0.153809 9.14743 0.211501 8.99999 0.326886 8.88461C0.44227 8.76922 0.589706 8.71153 0.769193 8.71153H6.92304L8.80766 2.98076C8.88458 2.69871 9.07689 2.55768 9.38458 2.55768C9.69227 2.55768 9.88458 2.69871 9.9615 2.98076L11.8461 8.71153H18C18.1795 8.71153 18.3269 8.76922 18.4423 8.88461C18.5577 8.99999 18.6153 9.14743 18.6153 9.32691C18.6153 9.53204 18.5256 9.69871 18.3461 9.82691L13.3461 13.25L15.2692 18.9808C15.2948 19.032 15.3077 19.0961 15.3077 19.1731C15.3077 19.3526 15.25 19.5 15.1346 19.6154C15.0192 19.7308 14.8718 19.7885 14.6923 19.7885Z" fill="black" />
                                                                        </svg>
                                                                        <Text style={styles.rate}>{object.rating}</Text>
                                                                    </View> : ""}
                                                            </View>
                                                        )
                                                    }
                                                </View>
                                                {
                                                    object.__typename == 'Object' && (
                                                        getMinDiscount(object.schedules) && getMinPrice(object.schedules) > getMinDiscount(object.schedules) ? (
                                                            <View style={{ flexDirection: 'row' }}>
                                                                <Text style={styles.price}>от </Text>
                                                                <Text style={[styles.price, { textDecorationLine: 'line-through', color: '#667085', fontWeight: '400' }]}>{getMinPrice(object.schedules)} ₽</Text>
                                                                <Text style={styles.price}> {getMinDiscount(object.schedules)} ₽</Text>
                                                            </View>
                                                        ) : (
                                                            <Text style={styles.price}>от {getMinPrice(object.schedules)} ₽</Text>
                                                        )
                                                    )
                                                }

                                                {
                                                    object.__typename == 'Tour' && (
                                                        <View>
                                                            <Text style={[styles.company, { maxWidth: squareSize - 32 }]}>Организатор: {object.organization}</Text>
                                                            <Text style={[styles.price, { marginTop: 9 }]}>{object.price} ₽</Text>
                                                        </View>
                                                    )
                                                }
                                            </TouchableOpacity>
                                        ))
                                    )
                                }
                            </View>
                        </View>
                    )
                }
                {
                    debouncedQuery == '' && (
                        findManyPromotion.map((promo, index) => (
                            <View key={index}>
                                <Text id={promo.anchor} style={styles.title}>{promo.name}</Text>
                                {
                                    <View>
                                        <ScrollView
                                            ref={el => objectScrollRefs.current[index] = el}
                                            style={{ marginBottom: 24 }}
                                            pagingEnabled
                                            horizontal
                                            showsHorizontalScrollIndicator={false}
                                        >
                                            {
                                                findManyObject.filter(object => promo.objects.includes(object.id)).length > 0 ?
                                                    findManyObject.filter(object => promo.objects.includes(object.id)).sort((a, b) => b.premium - a.premium).map((object, index) => (
                                                        <TouchableOpacity key={index} style={{ marginRight: 12, marginLeft: index === 0 ? 16 : 12 }} onPress={() => openObject(object.id)}>
                                                            <ImageBackground style={[styles.objectImage, { height: windowWidth > 767 ? squareSize : squareSize - 64, width: windowWidth > 767 ? squareSize : squareSize - 64 }]} source={object.images_720.length != 0 ? { uri: imageUrl(object.images_720[0]) } : { uri: imageUrl(object.images[0]) }}>
                                                                {
                                                                    user ? (
                                                                        <>
                                                                            {
                                                                                object.favorite ? (
                                                                                    <TouchableOpacity onPress={() => removeToFavorite(object.id)} style={styles.favorite}>
                                                                                        <Ionicons name='ios-heart-sharp' size={24} color='#475467' />
                                                                                    </TouchableOpacity>
                                                                                ) : (
                                                                                    <TouchableOpacity onPress={() => addToFavorite(object.id)} style={styles.favorite}>
                                                                                        <Ionicons name='ios-heart-outline' size={24} color='#475467' />
                                                                                    </TouchableOpacity>
                                                                                )
                                                                            }
                                                                        </>
                                                                    ) : <View />
                                                                }
                                                                <View style={styles.tagsContainer}>
                                                                    {
                                                                        getTags(object)
                                                                    }
                                                                </View>
                                                            </ImageBackground>
                                                            <View style={[styles.infoContainer, { justifyContent: 'space-between', marginTop: 8, alignItems: 'baseline', flexDirection: windowWidth > 767 ? 'row' : 'column-reverse' }]}>
                                                                <Text style={[styles.infoTitle, { maxWidth: windowWidth > 767 ? squareSize - 200 : squareSize - 64, marginVertical: windowWidth > 767 ? 0 : 4 }]}>{object.name}</Text>
                                                                <View style={[styles.infoGroup, { maxWidth: 250 }]}>
                                                                    {
                                                                        getPeople(object)
                                                                    }
                                                                    {
                                                                        getSquare(object.square)
                                                                    }
                                                                    {object.rating > 0 ?
                                                                        <View style={[styles.infoContainer, { justifyContent: 'space-between', alignItems: 'center' }]}>
                                                                            <Ionicons name='ios-star' size={20} color='#000' />
                                                                            <Text style={styles.rate}>{object.rating}</Text>
                                                                        </View> : ""}
                                                                </View>
                                                            </View>
                                                            {
                                                                getMinDiscount(object.schedules) && getMinPrice(object.schedules) > getMinDiscount(object.schedules) ? (
                                                                    <View style={{ flexDirection: 'row' }}>
                                                                        <Text style={styles.price}>от </Text>
                                                                        <Text style={[styles.price, { textDecorationLine: 'line-through', color: '#667085', fontWeight: '400' }]}>{getMinPrice(object.schedules)} ₽</Text>
                                                                        <Text style={styles.price}> {getMinDiscount(object.schedules)} ₽</Text>
                                                                    </View>
                                                                ) : (
                                                                    <Text style={styles.price}>от {getMinPrice(object.schedules)} ₽</Text>
                                                                )
                                                            }
                                                        </TouchableOpacity>
                                                    ))
                                                    : null
                                            }
                                            {
                                                findManyTour.filter(object => promo.tours.includes(object.id)).length > 0 ?
                                                    findManyTour.filter(object => promo.tours.includes(object.id)).map((object, index) => (
                                                        <TouchableOpacity style={{ marginRight: 12, marginLeft: index === 0 ? 16 : 12 }} key={index} onPress={() => openTour(object.id)}>
                                                            <ImageBackground style={[styles.objectImage, { height: windowWidth > 767 ? squareSize : squareSize - 64, width: windowWidth > 767 ? squareSize : squareSize - 64 }]} source={object.images_720.length != 0 ? { uri: imageUrl(object.images_720[0]) } : { uri: imageUrl(object.images[0]) }}>
                                                            </ImageBackground>
                                                            <View style={[styles.infoContainer, { justifyContent: 'space-between', marginTop: 8 }]}>
                                                                <View style={styles.infoGroup}>
                                                                    <Text style={[styles.infoTitle, { maxWidth: windowWidth > 767 ? squareSize - 32 : squareSize - 64 }]}>{object.name}</Text>
                                                                </View>
                                                            </View>
                                                            <Text style={[styles.company, { maxWidth: windowWidth > 767 ? squareSize - 32 : squareSize - 64 }]}>Организатор: {object.organization}</Text>
                                                            <Text style={[styles.price, { marginTop: 9 }]}>{object.price} ₽</Text>
                                                        </TouchableOpacity>
                                                    ))
                                                    : null
                                            }
                                            {
                                                findManyPost.filter(object => promo.posts.includes(object.id)).length > 0 ?
                                                    findManyPost.filter(object => promo.posts.includes(object.id)).map((object, index) => (
                                                        <TouchableOpacity style={{ marginRight: 12, marginLeft: index === 0 ? 16 : 12, width: windowWidth > 767 ? squareSize : squareSize - 64 }} key={index} onPress={() => navigation.navigate('Feed', { id: object.id })}>
                                                            <ImageBackground style={[styles.objectImage, { height: windowWidth > 767 ? squareSize : squareSize - 64, width: windowWidth > 767 ? squareSize : squareSize - 64 }]} source={{ uri: imageUrl(object.image) }}>
                                                            </ImageBackground>
                                                            <View style={[styles.infoContainer, { justifyContent: 'space-between', marginTop: 8 }]}>
                                                                <Text style={styles.infoTitle}>{object.user}</Text>
                                                                <Text style={styles.company}>{dayjs.unix(object.date).format('DD MMMM YYYY')}</Text>
                                                            </View>
                                                            <Text style={[styles.description, { width: windowWidth > 767 ? squareSize : squareSize - 64 }]}>{object.text ? `${object.text.slice(0, 120)}...` : ''}</Text>
                                                        </TouchableOpacity>
                                                    ))
                                                    : null
                                            }
                                        </ScrollView>
                                        {
                                            promo.objects.length >= 2 ? (
                                                <>
                                                    <TouchableOpacity onPress={() => onScrollPreview(objectScrollRefs.current[index])} style={[styles.scroll, { top: (squareSize / 2) - 18, display: windowWidth > 767 ? 'flex' : 'none' }]}>
                                                        <Ionicons name='chevron-back' size={24} color='#475467' />
                                                    </TouchableOpacity>
                                                    <TouchableOpacity onPress={() => onScrollNext(objectScrollRefs.current[index], promo.objects.length)} style={[styles.scroll, { top: (squareSize / 2) - 18, right: 0, display: windowWidth > 767 ? 'flex' : 'none' }]}>
                                                        <Ionicons name='chevron-forward' size={24} color='#475467' />
                                                    </TouchableOpacity>
                                                </>
                                            ) : promo.tours.length >= 2 ? (
                                                <>
                                                    <TouchableOpacity onPress={() => onScrollPreview(objectScrollRefs.current[index])} style={[styles.scroll, { top: (squareSize / 2) - 18, display: windowWidth > 767 ? 'flex' : 'none' }]}>
                                                        <Ionicons name='chevron-back' size={24} color='#475467' />
                                                    </TouchableOpacity>
                                                    <TouchableOpacity onPress={() => onScrollNext(objectScrollRefs.current[index], promo.tours.length)} style={[styles.scroll, { top: (squareSize / 2) - 18, right: 0, display: windowWidth > 767 ? 'flex' : 'none' }]}>
                                                        <Ionicons name='chevron-forward' size={24} color='#475467' />
                                                    </TouchableOpacity>
                                                </>
                                            ) : null
                                        }
                                    </View>
                                }
                            </View>
                        ))
                    )
                }
                <Footer />
            </Window>
        </ScrollView>
    )
}

const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;

const styles = StyleSheet.create({
    container: {
        flex: 1
    },
    wrapSegmentsContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginHorizontal: 16,
        marginTop: 16,
        marginBottom: 10,
        flexWrap: 'wrap'
    },
    segmentsContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
    },
    segmentContainer: {
        paddingHorizontal: 12,
        height: 32,
        alignItems: 'center',
        justifyContent: 'center',
        borderWidth: 1,
        borderColor: '#D0D5DD',
        borderRadius: 16,
        flexDirection: 'row',
    },
    segmentText: {
        color: '#667085',
        marginLeft: 6
    },
    selectSegmentContainer: {
        paddingHorizontal: 12,
        height: 32,
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 16,
        flexDirection: 'row',
        backgroundColor: '#BCC8B2'
    },
    selectSegmentText: {
        color: '#fff',
        marginLeft: 6,
    },
    searchContainer: {
        flexDirection: 'row',
        height: 56,
        borderRadius: 28,
        borderWidth: 1,
        borderColor: '#D0D5DD',
        alignItems: 'center',
        marginHorizontal: 16,
        marginBottom: 12
    },
    searchIcon: {
        marginHorizontal: 12
    },
    searchTitle: {
        color: '#101828',
        fontSize: 12,
        fontWeight: '500',
        marginBottom: 2
    },
    searchText: {
        color: '#98A2B3',
        fontSize: 12,
        fontWeight: '400'
    },
    title: {
        fontSize: 20,
        fontWeight: '500',
        marginHorizontal: 16,
        marginBottom: 16
    },
    objectsContainer: {
        gap: 24,
        marginHorizontal: 16,
        flexDirection: 'row',
        flexWrap: 'wrap'
    },
    objectImage: {
        borderRadius: 20,
        overflow: 'hidden',
        justifyContent: 'space-between'
    },
    infoContainer: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        flexWrap: 'wrap'
    },
    infoGroup: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    infoTitle: {
        fontSize: 18,
        fontWeight: '500',
        color: '#101828',
    },
    infoPeopleCount: {
        fontSize: 16,
        fontWeight: '400',
        color: '#101828',
        marginLeft: 2,
    },
    rate: {
        fontSize: 16,
        color: '#101828',
        marginLeft: 4
    },
    price: {
        color: '#101828',
        fontSize: 16,
        fontWeight: '500'
    },
    favorite: {
        height: 40,
        width: 40,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 20,
        backgroundColor: '#F2F4F7',
        alignSelf: 'flex-end',
        margin: 16
    },
    searchQueryResult: {
        fontSize: 16,
        lineHeight: '150%',
        fontWeight: 500,
        marginBottom: 26,
    },
    tagsContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: 16
    },
    tagHot: {
        height: 28,
        width: 135,
        borderRadius: 6,
        backgroundColor: '#E6B762',
        justifyContent: 'center',
        alignItems: 'center'
    },
    hotText: {
        color: '#FCFCFD',
        fontSize: 16,
        fontWeight: 'bold'
    },
    tagDeadline: {
        height: 28,
        width: 135,
        borderRadius: 6,
        backgroundColor: '#EAECF0',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    deadlineText: {
        color: '#000',
        fontSize: 14,
        fontWeight: '400',
        marginLeft: 4
    },
    company: {
        fontSize: 16,
        color: '#98A2B3',
        marginTop: 4
    },
    scroll: {
        height: 36,
        width: 36,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 18,
        backgroundColor: '#EAECF0',
        position: 'absolute',
        borderWidth: 1,
        borderColor: 'rgb(216, 216, 216)'
    },
    filterWrap: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    filterTabsWrap: {
        flexDirection: 'row',
        gap: 20,
        width: '100%',
        maxWidth: 618,
    },
    filterTabBtn: {
        color: '#6B7280',
        lineHeight: '150%',
        fontSize: 16,
        fontWeight: 500
    },
    filterTabBtnActive: {
        color: '#1F2A37',
        lineHeight: '150%',
        fontSize: 16,
        fontWeight: 500,
    },
    filterInputsWrap: {
        marginTop: 18,
        maxWidth: 618,
        width: '100%'
    },
    filterInputsWrapDate: {
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        borderColor: '#E5E7EB',
        borderWidth: 1,
        borderRadius: 50,
        padding: 8,
        paddingLeft: 20
    },
    filterInputsWrapSearch: {
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        borderColor: '#E5E7EB',
        borderWidth: 1,
        borderRadius: 50,
        padding: 8,
        paddingLeft: 20
    },
    filterInputDate: {
        fontSize: 14,
        color: '#1F2A37',
        minWidth: 130,
        fontWeight: 500
    },
    filterInputPeoples: {
        fontSize: 14,
        color: '#1F2A37',
        paddingLeft: 20,
        width: '100%',
        paddingHorizontal: 20,
        fontWeight: 500
    },
    filterInputBtn: {
        fontSize: 16,
        color: '#131313',
        lineHeight: '150%',
        fontWeight: 500,
        paddingHorizontal: 24,
        paddingVertical: 12,
        backgroundColor: '#E6B762',
        borderRadius: 50
    },
    modalComfortsWrapFirst: {
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10,
        position: 'relative',
        backgroundColor: windowWidth > 768 ? 'rgba(0, 0, 0, 0.5)' : 'none',
    },
    modalComfortsCloseBtn: {
        width: '100%',
        height: '100%',
        position: 'absolute',
    },
    modalComfortsWrap: {
        borderRadius: windowWidth > 768 ? 16 : 0,
        borderTopStartRadius: windowWidth > 768 ? 16 : 16,
        borderTopEndRadius: 16,
        maxWidth: 800,
        width: '100%',
        backgroundColor: '#fff',
        overflow: 'hidden',
        marginVertical: windowWidth > 768 ? 80 : 0,
        zIndex: 100,
        position: 'relative',
        minHeight: windowWidth > 768 ? '90vh' : '100vh',
        marginTop: windowWidth > 768 ? 80 : 101
    },
    modalComfortsClose: {
        backgroundColor: '#fff',
        paddingTop: windowWidth > 768 ? 24 : 22,
        paddingBottom: windowWidth > 768 ? 16 : 22,
        paddingHorizontal: windowWidth > 768 ? 24 : 22,
        borderBottomWidth: windowWidth > 768 ? 1 : 0,
        borderColor: '#E6E6E6',
    },
    modalComfortsTitle: {
        fontSize: 18,
        fontWeight: 600,
        lineHeight: '150%',
        color: '#111928'
    },
    modalComfortsForm: {
        paddingHorizontal: 24,
        paddingTop: 24,
        paddingBottom: 42
    },
    modalComfortsFormTitle: {
        fontSize: 18,
        fontWeight: 500,
        lineHeight: '150%',
        marginBottom: 16
    },
    modalComfortsFormCalendar: {
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderColor: '#D1D5DB',
        borderWidth: 1,
        borderRadius: 8,
        marginTop: 16,
    },
    modalComfortsFormBtnsWrap: {
        padding: 24,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderTopColor: '#E5E7EB',
        borderTopWidth: 1
    },
    modalComfortsFormRese: {
        padding: 24,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderTopColor: '#E5E7EB',
        borderTopWidth: 1
    },
    modalComfortsFormSubmit: {
        color: '#000',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '150%',
        backgroundColor: '#E6B762',
        borderRadius: 12,
        paddingHorizontal: 20,
        paddingVertical: 10
    },
    modalComfortsFormReset: {
        color: '#1F2A37',
        fontSize: 14
    },
    filterBtnMobile: {
        flexDirection: 'row',
        borderRadius: 99,
        borderWidth: 1,
        borderColor: '#E5E7EB',
        paddingVertical: 10,
        paddingHorizontal: 16,
        alignItems: 'center',
        gap: 12,
        width: '100%',
    },
    modalFilter: {
        backgroundColor: '#fff',
        height: '100vh'
    },
    modalFilterActive: {
        paddingTop: 48
    },
    modalFilterTop: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: 20,
        marginBottom: 20,
        marginHorizontal: 16
    },
    modalFilterClose: {
        padding: 10,
        borderColor: '#AEAEB2',
        borderWidth: 1,
        borderRadius: 50,
        zIndex: 10
    },
    modalFilterTabs: {
        flexDirection: 'row',
        gap: 20,
        position: 'absolute',
        width: '100%',
        justifyContent: 'center'
    },
    modalFilterTabsText: {
        color: '#6B7280',
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '150%',
    },
    modalFilterTabsTextActive: {
        color: '#1F2A37',
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '150%',
    },
    modalFilterDate: {
        marginHorizontal: 16,
        gap: 12,
        position: 'revert'
    },
    modalFilterInput: {
        lineHeight: '125%',
        fontSize: 14,
        fontWeight: 400,
        width: '100%'
    },
    modalFilterInputWrap: {
        borderRadius: 12,
        borderWidth: 1,
        borderColor: '#D1D5DB',
        paddingHorizontal: 16,
        paddingVertical: 18,
        backgroundColor: '#F9FAFB',
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: 8,
    },
    modalFilterDateBtns: {
        position: 'absolute',
        bottom: 64,
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center',
        left: 0,
        paddingHorizontal: 24,
    },

    modalFilterSearchBtns: {
        position: 'absolute',
        bottom: 64,
        flexDirection: 'row',
        justifyContent: 'flex-end',
        width: '100%',
        alignItems: 'center',
        left: 0,
        paddingHorizontal: 24,
    },
    modalFilterDateReset: {
        color: '#111928',
        lineHeight: '150%',
        fontWeight: 500,
        fontSize: 16
    },
    modalFilterDateSubmit: {
        backgroundColor: '#E6B762',
        paddingHorizontal: 24,
        paddingVertical: 12,
        borderRadius: 8,
        flexDirection: 'row',
        gap: 10
    },
    modalFilterDateSubmitText: {
        lineHeight: '150%',
        fontSize: 16,
        color: '#111928',
        fontWeight: 500,
    },
    searchList: {
        position: 'absolute',
        top: windowWidth > 768 ? 72 : 140,
        backgroundColor: '#fff',
        width: '100%',
        left: 0,
        paddingHorizontal: 20,
        paddingVertical: 24,
        borderRadius: 16,
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 1,
        },
        shadowOpacity: 0.22,
        shadowRadius: 2.22,

        elevation: 3,
    },
    searchListItem: {
        marginVertical: 8,
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8
    },
    filterInputDateDelete: {
        transform: [{ rotate: '45deg' }],
        position: 'absolute',
        right: '36px',
        fontSize: '16',
        fontWeight: 600,
        color: '#a3a3a3',
    },
    filterInputPeopleDelete: {
        position: 'absolute',
        transform: [{ rotate: '45deg' }],
        fontSize: '16',
        fontWeight: 600,
        color: '#a3a3a3',
        right: '4px',
        bottom: '0px'
    }
})

export default MainScreen
